import service from './config'
class HomeService {
    groupRetreat(param) {
        return service.post('/api/teammem/receivebygroupname',param)
    } 
    allRetreat() {
        return service.get('/api/teammem/receiveall')
    } 
    retreat(param){
    	return service.post('/api/teammem/receivebysn',param)
    	
    } 
    memberWithdraw(param){
        return service.post('/api/TeamMember/MemberWithdraw',param)
        
    }

    cancelRescuebysn(param){
    	return service.post('/api/teammem/cancelrescuebysn',param)
    }
    getalllist(){
    	return service.get('/api/build/getalllist')
    }
    getNewBuild(){
    	return service.get('/api/Build/GetNewBuild')
    }
    getLocationRecordList(){
    	return service.get('/api/locationrecord/getlocationrecordlist')
    } 
    initCorrecting(param){
    	return service.post('/api/LocationData/InitialPointCalibration',param)
    }
    manualCalibration(param){
    	return service.post('/api/LocationData/ManualCalibration',param)
    }
    heightCalibration(param){
    	return service.post('/api/LocationData/InitialFloorSet',param)
    }
    
    automaticStrongAlarmBySN(param){
    	return service.post('/api/teammem/automaticstrongalarmbysn',param)
    }
    manualAlarmBySN(param){
    	return service.post('/api/teammem/manualalarmbysn',param)
    }
    loadCalibration(param){
        return service.post('/api/build/lastlooaddata',param)
    }
    getLastLoadData(){
        return service.get('/api/Build/GetLastLoadData')
    }
    getTroopsTeamMemberStatus(){
        return service.get('api/TroopsInfo/GetTroopsTeamMemberStatus')
    } 
    getTroopsLocationList(){
        return service.get('api/LocationData/GetTroopsLocationList')
    }
    getTroopsTotalOffset(){
        return service.get('api/TroopsInfo/GetTroopsTotalOffset')
    }
    memberLocationReset(param){
        return service.post('api/TeamMember/MemberLocationReset',param) 
    }  
    ResetLastLoadData() {
        return service.delete('/api/Build/ResetLastLoadData')
    }
}
export default new HomeService()